import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RESONANCE_SORT, SORT_ORDER } from '../constants';

const useGenieMessagesSort = () => {
  const { t } = useTranslation('genie');

  return useMemo(
    () => [
      {
        label: 'R1',
        value: RESONANCE_SORT.R1,
        getSortValue: (message) => message?.interest,
      },
      {
        label: 'R2',
        value: RESONANCE_SORT.R2,
        getSortValue: (message) => message?.action,
      },
      {
        label: t('certainty'),
        value: RESONANCE_SORT.TOTAL,
        getSortValue: (message) => message?.uncertainty,
      },
    ],
    [t],
  );
};

export const COMMON_GENIE_SORT = {
  sort: RESONANCE_SORT.R1,
  direction: SORT_ORDER.DESC,
  getSortValue: (message) => message?.interest,
};

export default useGenieMessagesSort;
